import { ExcelImportDataSet, ExcelExplicitValue } from '../../views/components/excel-to-db-import-plugin/excel-to-db-import-plugin';
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject, transient } from 'aurelia-dependency-injection';
import { NotificationType, NotificationClientService } from '../basics/notification-client.service';

@autoinject
@transient()
export class ExcelImportClientService {

    constructor(private requestClient: RequestClientService, private notificationService: NotificationClientService) { }

    public import(excelDataSet: ExcelImportDataSet, entityType: number, notes: string = null, explicitValues: ExcelExplicitValue[] = null, filter: string = null, cultureCode: string = null, autoResolveErrors: boolean = false): Promise<any> {
        return this.requestClient.postFormData("ExcelImport/import", {
            entityTypeId: entityType,
            notes: notes,
            file: excelDataSet.excelFile,
            mappings: excelDataSet.mapping.mappings ? excelDataSet.mapping.mappings : [],
            explicitValues: explicitValues ? explicitValues : [],
            filter: filter,
            cultureCode: cultureCode,
            autoResolveErrors: autoResolveErrors
        });
    }

    public downloadTemplate(entityType: number, fileName: string) {
        try {
            $.ajax({
                type: "GET",
                url: "api/v1/ExcelImport/downloadTemplate/" + entityType,
                dataType: "text",
                data: {},
                success: x => {
                    const link = document.createElement('a');
                    link.download = fileName + '.xlsx';
                    link.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + x;
                    link.click();
                }
            });
        }
        catch (exception) {
            this.notificationService.show("Failed to export data to excel", "", NotificationType.Error);
        }
    }
}
